import { render, staticRenderFns } from "./UpdateTrailerStatusModal.vue?vue&type=template&id=3d4edb62&scoped=true"
import script from "./UpdateTrailerStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateTrailerStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4edb62",
  null
  
)

export default component.exports